/* Myoro JS — FAQ accordion exclusivity.
   Loaded once via layout/theme.liquid (defer).
   Note: file kept as `myoro-sticky-atc.js` for theme.liquid compatibility,
   but sticky ATC + announcement bar have been removed from the homepage. */
(function () {
  'use strict';

  // FAQ accordion: close others when one opens
  document.querySelectorAll('.myoro-faq__list').forEach(function (list) {
    list.addEventListener('toggle', function (e) {
      if (e.target.tagName !== 'DETAILS' || !e.target.open) return;
      list.querySelectorAll('details[open]').forEach(function (d) {
        if (d !== e.target) d.open = false;
      });
    }, true);
  });
})();
